import { motion } from 'framer-motion';
import { FaTwitter, FaLinkedin, FaFacebook, FaWhatsapp, FaLink, FaTelegram } from 'react-icons/fa';
import { useState } from 'react';

const SocialShare = ({ title, description, url }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || window.location.href;
  const shareTitle = title || 'Check this out!';
  const shareDescription = description || '';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareButtons = [
    {
      name: 'Twitter',
      icon: FaTwitter,
      color: 'hover:bg-[#1DA1F2]',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'LinkedIn',
      icon: FaLinkedin,
      color: 'hover:bg-[#0077B5]',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'Facebook',
      icon: FaFacebook,
      color: 'hover:bg-[#1877F2]',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'WhatsApp',
      icon: FaWhatsapp,
      color: 'hover:bg-[#25D366]',
      url: `https://wa.me/?text=${encodeURIComponent(shareTitle + ' ' + shareUrl)}`
    },
    {
      name: 'Telegram',
      icon: FaTelegram,
      color: 'hover:bg-[#0088cc]',
      url: `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`
    }
  ];

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm text-gray-400 mr-2">Share:</span>
      
      {shareButtons.map((button, index) => (
        <motion.a
          key={button.name}
          href={button.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`p-2 bg-gray-800 rounded-lg text-white transition-all ${button.color}`}
          whileHover={{ scale: 1.1, y: -2 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05 }}
          title={`Share on ${button.name}`}
        >
          <button.icon className="text-lg" />
        </motion.a>
      ))}

      {/* Copy Link Button */}
      <motion.button
        onClick={copyToClipboard}
        className={`p-2 rounded-lg text-white transition-all ${
          copied ? 'bg-green-500' : 'bg-gray-800 hover:bg-violet-500'
        }`}
        whileHover={{ scale: 1.1, y: -2 }}
        whileTap={{ scale: 0.95 }}
        title={copied ? 'Copied!' : 'Copy link'}
      >
        <FaLink className="text-lg" />
      </motion.button>

      {/* Copied Notification */}
      {copied && (
        <motion.span
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0 }}
          className="text-sm text-green-400"
        >
          Link copied!
        </motion.span>
      )}
    </div>
  );
};

export default SocialShare;
